// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a7aaf9b9","821":"ed1c0bd1"}[chunkId] + ".chunk.js";
};